<template>
	<base-modal
		:showCloseButton="true"
		:opened="isOpen"
		:maxWidth="'2xl'"
		@close="handleDecline"
	>
		<template #body>
			<div class="p-4 space-y-8">

				<div class="text-center space-y-3">
          <div
              class="bg-green-50 rounded-full p-4 inline-flex items-center justify-center"
          >
            <GiftTopIcon class="h-10 w-10 text-green-600" />
          </div>
					<h2 id="modal-headline" class="text-pretty white text-2xl md:text-3xl font-bold leading-tight">
						Congrats on passing your exam!
					</h2>
					<p class="text-lg text-gray-700 font-normal">
						Many technologists continue using Clover to earn CE credits and expand their skills.
					</p>
				</div>

				<div class="space-y-3">
					<div
						v-for="benefit in benefits"
						:key="benefit"
						class="flex items-start gap-2 bg-blue-50 rounded-md px-4 py-3"
					>
						<div class="w-6 h-6 shrink-0 mt-1">
							<CheckCircleIcon class="h-full w-full text-green-600 -mt-1" />
						</div>
						<p class="text-gray-800 font-semibold">{{ benefit }}</p>
					</div>
				</div>

				<div class="space-y-4 !mt-10">
					<div class="flex justify-center">
						<div class="mx-auto flex flex-col gap-2">
							<div class="text-3xl font-bold">Yearly</div>
							<div class="text-2xl font-bold">
								<span class="line-through text-gray-900 text-5xl decoration-red-700 relative after:content-['$199'] after:absolute after:bottom-[95%] after:left-[95%] after:-rotate-12 after:text-red-700 after:font-semibold">$356</span>
								<span class="sr-only">$199</span>
								<span class="text-gray-600 text-lg font-medium ml-2">/every 12 months</span>
							</div>
						</div>
					</div>
					<p class="text-sm text-gray-500 text-center italic">
						Automatically billed every 12 months at $199. Cancel anytime.
					</p>
				</div>

				<div class="flex flex-col items-stretch gap-4">
					<button
						type="button"
						class="button rounded-md bg-yellow-400 text-black hover:bg-yellow-300 border-none px-6 py-3 text-base font-semibold w-full md:w-auto"
						@click="startCheckout"
					>
						Claim my 44% Discount Now
					</button>
					<button
						type="button"
						class="text-gray-600 hover:text-gray-800 no-underline hover:underline text-sm"
						@click="handleDecline"
					>
						Cancel my subscription
					</button>
				</div>
			</div>
		</template>
	</base-modal>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { analytics } from "@/services/segment.ts";
import BaseModal from "./BaseModal.vue";
import { usePassedCertUpsellModalStore } from "@/stores/passedCertUpsellModalStore";
import {
	GiftTopIcon,
	CheckCircleIcon,
} from "@heroicons/vue/24/solid";
import { getEnv } from "@/env";

const emit = defineEmits<{
	(e: "decline"): void;
}>();

const benefits = [
	"Earn 60+ hours of ASRT-approved continuing education",
	"Learn new imaging modalities",
	"Stay current in your profession",
];

const modalStore = usePassedCertUpsellModalStore();
const isOpen = computed(() => modalStore.isOpen);

const startCheckout = () => {
	analytics.track("D2C Cancel Save Offer Accepted", { variant: "cert_upsell" });
	const plan = getEnv('VITE_CERT_UPSELL_PLAN', 'professional');
	const frequency = getEnv('VITE_CERT_UPSELL_FREQUENCY', '1y');
	const params = new URLSearchParams(window.location.search);
	params.set("plan", plan);
	params.set("frequency", frequency);
	params.set("cert_upsell", "1");
	window.location.href = `/account/checkout/offer-checkout-pay?${params.toString()}`;
};

const handleDecline = () => {
	analytics.track("D2C Cancel Save Offer Declined", { variant: "cert_upsell" });
	modalStore.close();
	emit("decline");
};

watch(isOpen, (val) => {
	if (val) analytics.track("D2C Cancel Save Offer Presented", { variant: "cert_upsell" });
});
</script>
